import { CaseService } from "@js/services/CaseService";
import { RoleService } from "@js/services/RoleService";
import {
  AddressLookupDTO,
  Case,
  CaseClient,
  CaseCrudClient,
  DevelopmentInput,
  DevelopmentInputClient,
  FileAttachment,
  FileAttachmentClient,
  FileAttachmentCrudClient,
  LenderResultClient,
  ModuleEnum,
  StreetAddressClient,
} from "@src/apis/ModularClient";
import { FileAttachmentHelper } from "@js/helpers/FileAttachmentHelper";
import { FileUploadProgressDTO } from "@js/DTO/FileUploadProgressDTO.cs";
import { Expand } from "@ccq/ts-lib";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class DevelopmentAppraisalScreenController {
  isLoggedInUser: boolean = false;

  fileUpload: Expand<FileAttachment>[];
  uploadingFiles: FileUploadProgressDTO[];
  case: Expand<Case, { readonly attachments: true; readonly developmentInput: true }>;
  caseTitle: string;
  openModal: boolean = false;
  thisModuleSection: ModuleEnum = ModuleEnum.DevelopmentAppraisal;
  total: number = 0;

  dataLoading: boolean = false;

  loanCriteria: DevelopmentInput;
  step: number = 1;
  dateOfOrigPurchMonth: number;
  dateOfOrigPurchYear: number;
  DevelopmentInputForm: ng.IFormController;
  caseid: number;
  searchid: number;
  totalPurchaseCostsOwning: number;
  additionalBuild: number;
  totalBuild: number;
  totalSales: number;
  totalPurchaseCostsNotOwning: number;
  totalNDV: number;
  contingencyCost: number;

  searchterm: string;
  PostCodeOptions: AddressLookupDTO[] = [];
  searchingForAddress: boolean = false;
  searchresults: string;

  criteriaPropertyForm: ng.IFormController;
  criteriaBorrowingForm: ng.IFormController;
  criteriaCostsForm: ng.IFormController;
  criteriaSalesForm: ng.IFormController;

  guidanceCheckbox: boolean = true;

  pageLoading: boolean = true;

  contingencyTotal: number;

  seeFiles: boolean = false;

  //array describing form sections
  formSectionNames = [
    {
      label: "Property",
      visible: true,
    },
    {
      label: "Build Costs",
      visible: true,
    },
    {
      label: "Borrowing",
      visible: true,
    },
    {
      label: "Sales",
      visible: true,
    },
  ];

  static $inject = [
    "$routeParams",
    "$rootScope",
    "$q",
    "DevelopmentInputClient",
    "$location",
    "LenderResultClient",
    "StreetAddressClient",
    "$cookies",
    "CaseService",
    "CaseClient",
    "FileAttachmentHelper",
    "FileAttachmentClient",
    "$window",
    "RoleService",
    "CaseCrudClient",
    "ODataHelper",
    "FileAttachmentCrudClient",
  ];

  constructor(
    private $routeParams: ng.route.IRouteParamsService,
    private $rootScope: ng.IRootScopeService,
    protected $q: ng.IQService,
    private developmentInputClient: DevelopmentInputClient,
    private $location: ng.ILocationService,
    private lenderResultClient: LenderResultClient,
    private streetAddressClient: StreetAddressClient,
    private $cookies: ng.cookies.ICookiesService,
    private $caseService: CaseService,
    private caseClient: CaseClient,
    private fileAttachmentHelper: FileAttachmentHelper,
    private fileAttachmentClient: FileAttachmentClient,
    private $window: ng.IWindowService,
    private roleService: RoleService,
    private caseCrudClient: CaseCrudClient,
    private odataHelper: ODataHelper,
    private fileAttachmentCrudClient: FileAttachmentCrudClient,
  ) {
    if ($cookies.get("access_token")) {
      this.isLoggedInUser = true;
    }

    //Init
    if (this.$routeParams.CaseId && this.$routeParams.SearchId) {
      this.caseid = this.$routeParams.CaseId;
      this.searchid = this.$routeParams.SearchId;
    } else {
      this.$location.path("/dashboard");
    }

    this.odataHelper
      .getOne(this.caseCrudClient, {
        filter: {
          id: {
            eq: Number(this.$routeParams.CaseId),
          },
        },
        expand: {
          developmentInput: true,
        },
      })
      .then((response) => {
        this.odataHelper
          .getMany(this.fileAttachmentCrudClient, {
            filter: {
              caseId: {
                eq: Number(this.$routeParams.CaseId),
              },
            },
          })
          .then((attachments) => {
            if (response == null) {
              if (this.isLoggedInUser) {
                this.$location.path("/userdashboard");
              }
            } else {
              this.fileUpload = attachments;
              this.case = response as typeof response & { attachments: any[] };
              this.case.attachments = attachments;
              this.$caseService.updateCaseState(this.case.id, this.case.caseStatus);
              this.caseTitle = response.developmentInput.searchName;
            }
          });
      });

    // Look up the existing search - must exist prior in order to have a case.

    this.developmentInputClient
      .fetch(this.searchid)
      .then((response) => {
        if (response == null) {
          if (this.isLoggedInUser) {
            this.$location.path("/userdashboard");
          }
        } else {
          this.loanCriteria = response;
          if (this.loanCriteria) {
            this.calcContingencyCost();
            if (this.loanCriteria.cI_Dev_DateOfOrigPurch) {
              this.dateOfOrigPurchMonth = this.loanCriteria.cI_Dev_DateOfOrigPurch.getMonth() + 1;
              this.dateOfOrigPurchYear = this.loanCriteria.cI_Dev_DateOfOrigPurch.getFullYear() % 100;
            }
            if (!this.loanCriteria.dI_PurchaseAgentFees) {
              this.loanCriteria.dI_PurchaseAgentFees = 0;
            }
            if (!this.loanCriteria.dI_PurchaseLegalFees) {
              this.loanCriteria.dI_PurchaseLegalFees = 0;
            }
            if (!this.loanCriteria.dI_PurchaseOtherFees) {
              this.loanCriteria.dI_PurchaseOtherFees = 0;
            }
            this.recalcContingencyTotal();
          }
        }
      })
      .catch((error) => {
        this.$location.path("/dashboard");
      })
      .finally(() => {
        this.pageLoading = false;
      });

    if (this.$routeParams.StepNumber) {
      this.step =
        this.$routeParams.StepNumber > 4 || this.$routeParams.StepNumber < 1 ? 1 : this.$routeParams.StepNumber;
    } else {
      if (this.isLoggedInUser) {
        this.go("/criteriaappraisal/" + this.caseid + "/" + this.searchid + "/" + this.step);
      }
    }

    this.updateGuidanceState();

    $rootScope.$on("guidanceStateChanged", (event: ng.IAngularEvent) => {
      this.updateGuidanceState();
    });
  }

  updateVatOnLandPurchase(value: number): void {
    if (value === 1) {
      //if yes, show vat amount question prepopulated with 20% of purchase price
      this.loanCriteria.landPurchaseVatAmount = this.loanCriteria.cI_Dev_OrigPP * 0.2;
    }
    this.loanCriteria.payingVATOnLandPurchase = value;
    this.CalcTotalPurchaseCostsOwning();
    this.CalcTotalPurchaseCostsOwning();
  }

  indexPopup(methodName: string) {
    this.$rootScope.$broadcast(methodName);
  }

  updateGuidanceState() {
    this.guidanceCheckbox = this.$cookies.get("guidance") === "on" || this.$cookies.get("guidance") === undefined;
  }

  getGuidanceSwitchState() {
    if (!this.$cookies.get("guidance")) {
      this.guidanceCheckbox = true;
    } else if (this.$cookies.get("guidance") === "on") {
      this.guidanceCheckbox = true;
    } else if (this.$cookies.get("guidance") === "off") {
      this.guidanceCheckbox = false;
    } else {
      this.guidanceCheckbox = true;
    }
    return this.guidanceCheckbox;
  }

  recordGuidanceCookie() {
    var guidanceSwitchState: string;
    var expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 365);
    if (this.guidanceCheckbox == true) {
      guidanceSwitchState = "on";
    } else {
      guidanceSwitchState = "off";
    }
    this.$cookies.put("guidance", guidanceSwitchState, { expires: expiryDate });
    this.$rootScope.$broadcast("guidanceStateChanged");
  }

  setAllFormsPristine(): void {
    if (this.criteriaPropertyForm) {
      this.criteriaPropertyForm.$setPristine();
    }
    if (this.criteriaBorrowingForm) {
      this.criteriaBorrowingForm.$setPristine();
    }
    if (this.criteriaCostsForm) {
      this.criteriaCostsForm.$setPristine();
    }
    if (this.criteriaSalesForm) {
      this.criteriaSalesForm.$setPristine();
    }
  }

  back(): void {
    this.save().then(() => {
      if (this.step > 0) {
        this.step--;
      }

      this.go("/criteriaappraisal/" + this.caseid + "/" + this.searchid + "/" + this.step);
    });
  }

  next(): void {
    this.save().then(() => {
      this.goToNextStep();
    });
  }

  /** Go to the next step */
  goToNextStep() {
    if (this.step == 6) {
      // Store the search on rootScope.
      //(this.$rootScope as any).loanCriteria = this.loanCriteria;
      //this.$location.path("/results");
    }
    this.step++;
    this.go("/criteriaappraisal/" + this.caseid + "/" + this.searchid + "/" + this.step);
  }

  goToCaseDashboard(save: boolean = false): void {
    if (!this.roleService.IsLender) {
      this.save();
      (this.$rootScope as any).formSaved = true;
    }

    this.$location.path("/casedashboard/" + this.caseid);
  }
  go(path): void {
    if (!this.roleService.IsLender) {
      this.save().then((response) => {
        this.$location.path(path);
      });
    } else {
      this.$location.path(path);
    }
  }

  setDate(dateToUpdate: Date, month: number, year: number) {
    // Two digit years!
    var fullYear: number;
    var today = new Date();
    if (today.getFullYear() < 2000 + year) {
      // If it's after this year, we probably mean 19xx.
      fullYear = 1900 + year;
    } else {
      // Otherwise it's probably in the 2000s.
      fullYear = 2000 + year;
    }
    dateToUpdate.setUTCFullYear(fullYear);
    // Note: Months are 0 based.
    dateToUpdate.setUTCMonth(month - 1);
  }

  calcContingencyCost(): number {
    if (this.pageLoading === false) {
      var res: number = 0;
      if (this.contingencyTotal == 0) {
        if (this.loanCriteria.cI_Dev_Contingency && this.loanCriteria.cI_Dev_BuildCosts) {
          res = this.loanCriteria.cI_Dev_Contingency * this.loanCriteria.cI_Dev_BuildCosts;
          this.contingencyTotal = res;
          return res;
        }
      }

      return this.contingencyTotal;
    }
  }

  recalcContingencyTotal(): void {
    let res: number = 0;
    //Case 1 - recalc Build costs
    if (this.loanCriteria.cI_Dev_Contingency && this.loanCriteria.cI_Dev_BuildCosts) {
      res = this.loanCriteria.cI_Dev_Contingency * this.loanCriteria.cI_Dev_BuildCosts;
      this.contingencyTotal = res;
    }
  }

  CalcTotalPurchaseCostsNotOwning(): number {
    if (this.pageLoading === false) {
      var res: number = 0;
      if (this.loanCriteria.cI_Dev_OrigPP) {
        res += Number(this.loanCriteria.cI_Dev_OrigPP);
      }
      if (this.loanCriteria.cI_Dev_SDLT) {
        res += Number(this.loanCriteria.cI_Dev_SDLT);
      }
      //if (this.loanCriteria.cI_Land_Total_other_Costs) {
      //    res += Number(this.loanCriteria.cI_Land_Total_other_Costs)
      //}
      if (this.loanCriteria.dI_PurchaseAgentFees) {
        res += Number(this.loanCriteria.dI_PurchaseAgentFees);
      }
      if (this.loanCriteria.dI_PurchaseLegalFees) {
        res += Number(this.loanCriteria.dI_PurchaseLegalFees);
      }
      if (this.loanCriteria.dI_PurchaseOtherFees) {
        res += Number(this.loanCriteria.dI_PurchaseOtherFees);
      }
      if (this.loanCriteria.payingVATOnLandPurchase === 1) {
        res += Number(this.loanCriteria.landPurchaseVatAmount);
      }
      //this.loanCriteria.dev_TotLndCostAdj = res;
      this.totalPurchaseCostsNotOwning = res;
      return res;
    }
  }

  CalcTotalPurchaseCostsOwning(): number {
    if (this.pageLoading === false) {
      var res: number = 0;
      if (this.loanCriteria.cI_Dev_OrigPP) {
        res += Number(this.loanCriteria.cI_Dev_OrigPP);
      }
      if (this.loanCriteria.cI_Dev_SDLT) {
        res += Number(this.loanCriteria.cI_Dev_SDLT);
      }
      if (this.loanCriteria.dI_PurchaseAgentFees) {
        res += Number(this.loanCriteria.dI_PurchaseAgentFees);
      }
      if (this.loanCriteria.dI_PurchaseLegalFees) {
        res += Number(this.loanCriteria.dI_PurchaseLegalFees);
      }
      if (this.loanCriteria.dI_PurchaseOtherFees) {
        res += Number(this.loanCriteria.dI_PurchaseOtherFees);
      }
      if (this.loanCriteria.payingVATOnLandPurchase === 1) {
        res += Number(this.loanCriteria.landPurchaseVatAmount);
      }
      //this.loanCriteria.dev_TotLndCostAdj = res;
      this.totalPurchaseCostsOwning = res;
      return res;
    }
  }
  CalcTotalBuild(): number {
    if (this.pageLoading === false) {
      let res: number = this.CalcAdditionalBuild();
      if (this.loanCriteria.cI_Dev_BuildCosts) {
        res += Number(this.loanCriteria.cI_Dev_BuildCosts);
      }
      if (this.contingencyTotal) {
        res += Number(this.contingencyTotal);
      }
      //this.loanCriteria.dev_TotBuildCostsAdj = res;
      //this.loanCriteria.cI_Dev_BuildCosts = res;
      this.totalBuild = res;
      return res;
    }
  }
  CalcTotalSales(): number {
    if (this.pageLoading === false) {
      let res: number = 0;
      if (this.loanCriteria.dI_Sales_Dressing) {
        res += Number(this.loanCriteria.dI_Sales_Dressing);
      }
      if (this.loanCriteria.dC_SalesAgentFees) {
        res += Number(this.loanCriteria.dC_SalesAgentFees);
      }
      if (this.loanCriteria.dC_SalesLegalFeesPercent) {
        res += Number(this.loanCriteria.dC_SalesLegalFeesPercent);
      }
      this.totalSales = res;
      return res;
    }
  }

  CalcNDV(): number {
    if (this.pageLoading === false) {
      let gdv: number = 0;
      let sales: number = 0;
      if (this.loanCriteria.cI_UseGDVCalculated === false && this.loanCriteria.cI_GDV) {
        gdv = Number(this.loanCriteria.cI_GDV);
      }
      if (this.loanCriteria.cI_UseGDVCalculated === true && this.loanCriteria.cI_GDVCalculated) {
        gdv = Number(this.loanCriteria.cI_GDVCalculated);
      }
      if (this.totalSales) {
        sales = Number(this.totalSales);
      }
      let ndv: number = Number(gdv - sales);
      if (ndv <= 0) {
        ndv = Number(0);
      }
      this.totalNDV = ndv;
      return ndv;
    }
  }

  CalcAdditionalBuild(): number {
    if (this.pageLoading === false) {
      let res: number = 0;
      if (this.loanCriteria.dI_BreakDownBuildCosts) {
        if (this.loanCriteria.cI_Dev_ProfPlanning) {
          res += Number(this.loanCriteria.cI_Dev_ProfPlanning);
        }
        if (this.loanCriteria.cI_Dev_ProfQS) {
          res += Number(this.loanCriteria.cI_Dev_ProfQS);
        }
        if (this.loanCriteria.dI_BuildProjectManag) {
          res += Number(this.loanCriteria.dI_BuildProjectManag);
        }
        if (this.loanCriteria.cI_Dev_S106CIL) {
          res += Number(this.loanCriteria.cI_Dev_S106CIL);
        }
        if (this.loanCriteria.dI_BuildMechEng) {
          res += Number(this.loanCriteria.dI_BuildMechEng);
        }
        if (this.loanCriteria.dI_BuildStrucEng) {
          res += Number(this.loanCriteria.dI_BuildStrucEng);
        }
        if (this.loanCriteria.dI_BuildPartyWall) {
          res += Number(this.loanCriteria.dI_BuildPartyWall);
        }
        if (this.loanCriteria.dI_BuildLandscaping) {
          res += Number(this.loanCriteria.dI_BuildLandscaping);
        }
        if (this.loanCriteria.dI_BuildWarranty) {
          res += Number(this.loanCriteria.dI_BuildWarranty);
        }
        if (this.loanCriteria.dI_BuildDemolition) {
          res += Number(this.loanCriteria.dI_BuildDemolition);
        }
        if (this.loanCriteria.dI_BuildOtherCosts) {
          res += Number(this.loanCriteria.dI_BuildOtherCosts);
        }
      } else {
        if (this.loanCriteria.cI_Dev_AdditionalOngoingCosts) {
          res += Number(this.loanCriteria.cI_Dev_AdditionalOngoingCosts);
        }
      }
      this.additionalBuild = res;
      return res;
    }
  }
  save(): ng.IPromise<number> {
    //this.loanCriteria.saveQueryAndResults = true;
    let defer = this.$q.defer<number>();
    if (!this.loanCriteria) {
      return defer.promise;
    }
    this.developmentInputClient
      .addUpdateReturnOnlyID(this.loanCriteria)
      .then((response) => {
        this.lenderResultClient
          .productsOfferingLargestLoanAndMatching(
            true,
            true,
            20,
            false,
            "",
            "",
            "",
            this.loanCriteria.searchName,
            true,
            this.loanCriteria,
          )
          .then((results) => {
            this.setAllFormsPristine();
          })
          .catch((error) => {})
          .finally(() => {});
        defer.resolve(response as number);
        return response;
      })
      .catch((response) => {
        defer.reject(response);
      });

    return defer.promise;
  }

  formChanged(): void {
    (this.$rootScope as any).formSaved = false;
  }

  getAddressList(app, searchTerm: string) {
    let foundMatch = false;

    if (this.PostCodeOptions && this.PostCodeOptions && this.PostCodeOptions.length > 0) {
      let addressLookup = this.PostCodeOptions.find((add) => {
        return add.addressLine1 + " " + add.addressLine2 === searchTerm;
      });

      if (addressLookup && !(addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;

        // We've selected an address!
        this.streetAddressClient.getFullAddress((addressLookup as AddressLookupDTO).id).then((address) => {
          app.dI_StreetAddress = address;
          this.searchterm = "";
        });
      } else if (addressLookup && (addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;
        this.loanCriteria.dI_StreetAddress.addressLine1 = addressLookup.addressLine2;
        this.loanCriteria.dI_StreetAddress.addressLine2 = addressLookup.addressLine3;
        this.loanCriteria.dI_StreetAddress.addressLine3 = addressLookup.addressLine4;
        this.loanCriteria.dI_StreetAddress.addressLine4 = addressLookup.postCode;
        this.loanCriteria.dI_StreetAddress.postCode = addressLookup.addressLine1;
        this.searchterm = "";
      }
    }

    if (searchTerm.length >= 3 && !foundMatch) {
      this.searchingForAddress = true;
      // Initial search term
      this.PostCodeOptions = [];

      this.streetAddressClient
        .getAddressList(searchTerm)
        .then((response) => {
          this.PostCodeOptions = response;
        })
        .finally(() => {
          this.searchingForAddress = false;
        });
    }
  }
  sum(a: number, b: number): number {
    return a + b;
  }

  //File upload

  onFileSelect(files: FileAttachment[], module: ModuleEnum) {
    if (files.length > 0) {
      this.fileAttachmentHelper
        .UploadFileLstInSync(files, this.uploadingFiles, this.case.id, this.fileUpload, module)
        .then((result) => {
          this.openModal = false;
        });
    }
  }

  downloadFile(file: FileAttachment) {
    this.fileAttachmentClient
      .getAmazonFileAccessUri(file.fileLocation)
      .then((uri) => {
        this.$window.open(uri);
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  deleteFile(file: FileAttachment) {
    this.fileUpload.splice(this.fileUpload.indexOf(file), 1);
    this.fileAttachmentClient.markAsDeleted(file.id).then((result) => {});
  }

  calculateTotalFiles(filter: number) {
    if (this.fileUpload) {
      this.total = this.fileUpload.filter((item) => item.module === filter).length;
    }
    return this.total;
  }

  viewResults() {
    if (!this.roleService.IsLender) {
      this.save();
      (this.$rootScope as any).formSaved = true;
    }
    this.$location.path("/results/" + this.case.developmentInputId + "/" + this.case.id);
  }
}
